import constants from './constants';
import axios from 'axios';
import { KeepAlive } from '../keep-alive';
import { getShellActions } from '@nab/x-runtime';
import { IOSGIConfig } from '../interfaces';
import { getTokenCacheStrategy } from 'runtime/auth-token-cache-strategy';

export const sessionKeepAlive = (config: IOSGIConfig) => {
	const heartbeat = async () => {
		const keepAliveEndpoint =
			config.keepAliveConfig.keepAliveEndpoint ??
			constants.OAUTH_KEEP_ALIVE_ENDPOINT;
		const url: string = config.keepAliveConfig.endpoint + keepAliveEndpoint;
		const tokens = getTokenCacheStrategy().authTokenCacheStrategy.getAllTokens();

		for (const token of tokens) {
			try {
				if (token.token.config?.isSeed) {
					await axios.get(url, {
						headers: {
							authorization: `bearer ${token.token.tokenValue}`,
						},
					});
				}
			} catch (e) {
				console.warn('Unable to use token for the heart-beat call', e);
			}
		}
	};

	return new KeepAlive({
		idleTime: config.keepAliveConfig.idleTime,
		heartbeatProvider: heartbeat,
		onUserInActive: () => {
			getShellActions().dispatchEvent(
				constants.APP_SHELL_KEEP_ALIVE_USER_INACTIVE,
			);
		},
	});
};
